module.exports = __webpack_public_path__ + "img/default-profile.2cab1ed4.png";